import React from 'react';
import PropTypes from 'prop-types';

import { Tabs as MUITabs } from '@mui/material';

export const Tabs = props => <MUITabs {...props} />;

Tabs.propTypes = {
  centered: PropTypes.bool,
  classes: PropTypes.object,
  indicatorColor: PropTypes.oneOf(['primary', 'secondary']),
  onChange: PropTypes.func,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  scrollButtons: PropTypes.oneOf(['auto', 'desktop', 'on', 'off']),
  textColor: PropTypes.oneOf(['primary', 'secondary', 'inherit']),
  value: PropTypes.any,  // eslint-disable-line react/forbid-prop-types
  variant: PropTypes.oneOf(['standard', 'scrollable', 'fullWidth'])
};

export default Tabs;
